import { TouchEvent, MouseEvent } from 'react';

export const handleSwipeListeners = ({
    action, isTouchDevice, swipeMove, swipeEnd, preventClick
}: {
    swipeEnd: () => void;
    isTouchDevice: boolean;
    action: 'add' | 'remove';
    swipeMove: (event: Event) => void;
    preventClick: (event: Event) => void;
}) => {
    const actionMethod = action === 'add' ? 'addEventListener' : 'removeEventListener';

    if (isTouchDevice) {
        document.body[actionMethod]('touchmove', swipeMove);
        document.body[actionMethod]('touchcancel', swipeEnd);
        document.body[actionMethod]('touchend', swipeEnd);
        document.body[actionMethod]('tap', preventClick);
    } else {
        document.body[actionMethod]('mousemove', swipeMove);
        document.body[actionMethod]('mouseup', swipeEnd);
        document.body[actionMethod]('mouseleave', swipeEnd);
        document.body[actionMethod]('click', preventClick);
    }
};

export const getAngleDegrees = (deltaX: number, deltaY: number): number => {
    return Math.atan(Math.abs(deltaY) / Math.abs(deltaX)) * 180 / Math.PI;
};

export const getTouchPosition = (event: Event): { posX: number; posY: number } => {
    const isTouchEvent = event instanceof TouchEvent;
    const isMouseEvent = event instanceof MouseEvent;

    const posX = isTouchEvent
        ? event.changedTouches?.[0].clientX
        : isMouseEvent ? event.clientX : 0;
    const posY = isTouchEvent
        ? event.changedTouches?.[0].clientY
        : isMouseEvent ? event.clientY : 0;

    return { posX, posY };
};
